<div id="content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
          <h1>{{ page_title }}</h1>
          <button mat-flat-button color="accent" (click)="createDocumentType()">
            <mat-icon>add</mat-icon>
            Crear
          </button>
        </div>

        <div class="bisual-table">
          <form class="card paginator" [formGroup]="filterForm">
            <mat-paginator
              [length]="length"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [pageIndex]="pageIndex"
              (page)="changePage($event)"
              style="margin-right: auto"
            ></mat-paginator>

            <mat-form-field>
              <input matInput type="text" formControlName="search" />
              <button matSuffix mat-icon-button aria-label="Clear">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>
          </form>

          <div class="bisual-table-container">
            <div class="row">
              <div class="col-12">
                <mat-card>
                  <mat-card-content>
                    <div class="table-responsive">
                      <table mat-table [dataSource]="dataSource" class="w-100">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef>Nombre</th>
                          <td mat-cell *matCellDef="let element">
                            <div class="d-flex align-items-center">
                              <span
                                class="fw-bold text-truncate"
                                style="max-width: 200px"
                                [matTooltip]="element.name.length > 25 ? element.name : null"
                                matTooltipPosition="above"
                              >
                                {{ element.name }}
                              </span>
                            </div>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="related_type">
                          <th mat-header-cell *matHeaderCellDef>Relación</th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.relatedTypeLabel }}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="related_user_can_view_document">
                          <th mat-header-cell *matHeaderCellDef>Visibilidad</th>
                          <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                              <mat-chip [color]="element.related_user_can_view_document ? 'primary' : 'accent'">
                                {{ element.publicLabel }}
                              </mat-chip>
                            </mat-chip-set>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="documents_count">
                          <th mat-header-cell *matHeaderCellDef>Documentos</th>
                          <td mat-cell *matCellDef="let element">
                            <span class="badge bg-secondary">{{ element.documents_count }}</span>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef>Acciones</th>
                          <td mat-cell *matCellDef="let element">
                            <div class="d-flex gap-2">
                              <button mat-icon-button color="warn" (click)="deleteDocumentType(element)" matTooltip="Eliminar">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
